<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col cols="6" class="pa-0">
        <AuthSidebar />
      </v-col>
      <v-col cols="6" class="pa-0">
        <!-- <LanguageSelection class="float-right" /> -->
        <div class="right-section">
          <v-row no-gutters align="center">
            <v-col cols="8" class="text-right">
              Not a member?
              <router-link class="forget primary--text" to="/register"
                >Request access
              </router-link>
            </v-col>
            <v-col cols="3">
              <LanguageSelection class="float-right" />
            </v-col>
          </v-row>
          <!-- <div class="login-details">
						<h2>Not a member? 
							<router-link class="forget primary--text" to="/register">Request access </router-link>
						</h2>
					</div> -->
          <div class="flex-direction-box">
            <div class="login-from vertical-center">
              <h2>{{ "Forgot Password ?" }}</h2>
              <p class="gray--text">{{ "OTP has been sent to your mobile number. Please enter the OTP value." }}</p>
              <form @submit.prevent="checkAuth">
                <div class="login-from-fill">
                  <div class="form-group">
                    <v-text-field
                      outlined
                      type="number"
                      v-model.trim="otp"
                      prepend-inner-icon=""
                      :error-messages="errors.otp"
                      placeholder="Enter OTP Value"
                    ></v-text-field>
                  </div>
                  <!-- <div class="form-group">
                    <v-text-field
                      :type="passwordType"
                      outlined
                      v-model.trim="password"
                      prepend-inner-icon="mdi-lock-outline"
                      :append-icon="passwordIcon"
                      :error-messages="errors.password"
                      @click:append="changePasswordType"
                      :placeholder="$t('password') + '*'"
                    ></v-text-field>
                  </div> -->
                  <v-btn type="submit" block color="primary" class="mb-2">{{
                   "Submit"
                  }}</v-btn>
                </div>
				   <!-- <router-link class="text-center forget primary--text" to="/login">Back to Login</router-link> -->
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";

import AuthSidebar from "./AuthSidebar.vue";
export default {
  components: {
    AuthSidebar,
  },
  computed: {
    isAuthErr() {
      return this.authErr.length > 0;
    },
  },
  data() {
    return {
      error: false,
      errors: { username: "", },
      username: "",
      authErr: "",
    };
  },
  methods: {
    // changePasswordType() {
    //   console.log("test");
    //   if (this.passwordType == "password") {
    //     this.passwordType = "text";
    //     this.passwordIcon = "mdi-eye-off";
    //   } else {
    //     this.passwordType = "password";
    //     this.passwordIcon = "mdi-eye";
    //   }
    // },
    async checkAuth() {
      this.startLoading();
      this.emptyErrors();
      // form Validations
      if (!this.validForm()) {
        this.stopLoading();
        return false;
      }
      console.log("sdffs");
      // form validations end
      const authData = {
        email: this.username,
      };
      try {
        await this.$store.dispatch("forgetPassword", authData);
        this.stopLoading();
        this.$router.replace({ name: "ConfirmForgotPassword" });
      } catch (error) {
        this.authErr = error;
        this.$notify({
          title: "Unable to Login",
          text: error,
          type: "error",
        });
        this.stopLoading();
      }
    },
    emptyErrors() {
      this.error = false;
      this.errors.username = "";
      this.errors.password = "";
      this.authErr = "";
    },

    validForm() {
      if (this.username == "") {
        this.errors.username = "Email can not be empty.";
        this.error = true;
      } 
      if (this.error) return false;

      return true;
    },
  },
  mixins: [loading, generalMixin],
};
</script>

<style scoped lang="scss">
.right-section {
  padding: 6px 20px;
  background-color: white;
  height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.right-section .login-details {
  text-align: end;
}
.right-section .login-details h2 {
  font-size: 14px;
  font-family: pop_regular;
  font-weight: 100;
}
.right-section .login-details h2 a {
  color: #aabdcf;
  font-family: pop_semiBold;
  text-decoration: none;
  margin-left: 4px;
}
.right-section .login-from h2 {
  font-size: 30px;
  font-family: pop_semiBold;
  font-weight: 600;
  margin-bottom: 0px;
}
.right-section .login-from p {
  color: #aabdcf;
  font-size: 12px;
  font-family: pop_regular;
  width: 308px;
  margin-top: 3px;
}
.flex-direction-box {
  height: 546px;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-from-fill label {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: #97a8b8;
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
}
.login-from-fill .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #e7f0f8;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
}
.login-from-fill {
  margin-top: 31px;
}

.login-from-fill .forget {
  font-size: 14px;
  font-family: Poppins-Medium;
  text-decoration: none;
  display: block;
  margin-top: 9px;
  text-align: center;
}

/*forgot css*/
.login-from-fill .form-group.phone-number {
  display: flex;
}
.login-from-fill .number-list {
  width: 52px;
  padding: 6px 4px;
  border-radius: 3px 0px 0px 3px;
  background: #aabdcf;
  color: #fff;
  font-size: 13px;
  height: 38px;
  border: 0px;
}
.login-from-fill .form-control.phone-control {
  margin: 0px;
  border-radius: 0px 3px 3px 0px;
}
select:focus-visible {
  outline: none;
}
input.form-control:focus-visible {
  outline: none;
}
.form-control::placeholder {
  font-size: 13px;
  font-family: pop_regular;
}
.login-from .emailgroup .form-control::placeholder {
  font-size: 13px;
  font-family: pop_semiBold;
}
// .router-link{
// 	align-items: center;
// }
</style>
